// Place z-indexes below, in order that they should stack in the DOM
// Please ensure this is up to date with ./zindexes.css
export const zindexUnder = -1;
export const zindexCanvas = 0;
export const zindexElevated = 1;
export const zindexMenu = 2;
export const zindexNoteHeader = 3;
export const zindexPopup = 3;
export const zindexPaywall = 3;
export const zindexProsemirrorMenu = 3;
export const zindexStreamHeader = 4;
export const zindexNavbar = 5;
export const zindexDimmer = 5;
export const zindexDropdown = 6;
export const zindexModal = 6;
export const zindexProseToolbar = 10;
export const zindexConfetti = 20;
export const zindexSentry = 1001;
export const zindexRadixPopper = 2147483647; /* "This was the former default value for radix menus" -Ellie */

// This should be above all other z-indexes so that tutorial elements show above everything else
export const zindexTourOverlay = 2147483648;
